import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconDocumentation = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M15 8.25002C14.5858 8.25002 14.25 8.5858 14.25 9.00002C14.25 9.41423 14.5858 9.75002 15 9.75002H18C18.4142 9.75002 18.75 9.41423 18.75 9.00002C18.75 8.5858 18.4142 8.25002 18 8.25002H15Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.25 12.5C14.25 12.0858 14.5858 11.75 15 11.75H18C18.4142 11.75 18.75 12.0858 18.75 12.5C18.75 12.9142 18.4142 13.25 18 13.25H15C14.5858 13.25 14.25 12.9142 14.25 12.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15 15.25C14.5858 15.25 14.25 15.5858 14.25 16C14.25 16.4142 14.5858 16.75 15 16.75H18C18.4142 16.75 18.75 16.4142 18.75 16C18.75 15.5858 18.4142 15.25 18 15.25H15Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M9.08402 2.45119C10.6463 2.91117 11.7482 3.71293 12.3732 4.25002H19.19C20.7586 4.25002 22 5.5696 22 7.1369V17.8527C22 19.4152 20.7633 20.75 19.19 20.75H4.81C3.26578 20.75 2 19.4842 2 17.94V6.96999C2 5.42577 3.26578 4.15999 4.81 4.15999H5.09V3.87002C5.09 2.88098 5.89663 2.05535 6.91586 2.0905C7.54211 2.11247 8.2863 2.21103 9.08402 2.45119ZM6.59 3.87002C6.59 3.69906 6.7234 3.58475 6.86417 3.58961C7.3772 3.60764 7.9924 3.68885 8.65358 3.88811L8.65837 3.88953C9.8403 4.23716 10.7082 4.8229 11.25 5.26567V17.9715C10.7396 17.5242 10.0876 17.0795 9.27457 16.7461L9.27296 16.7455C8.36358 16.375 7.5054 16.2539 6.84745 16.221L6.83725 16.2205C6.70877 16.2159 6.59 16.1049 6.59 15.95V3.87002ZM12.75 19.25V5.75002H19.19C19.8814 5.75002 20.5 6.3484 20.5 7.1369V17.8527C20.5 18.646 19.8767 19.25 19.19 19.25H12.75ZM10.4264 19.25C10.0017 18.8478 9.43544 18.4335 8.70631 18.1343C7.99783 17.8458 7.31803 17.7467 6.77686 17.7193C5.80831 17.681 5.09 16.8733 5.09 15.95V5.65999H4.81C4.09421 5.65999 3.5 6.2542 3.5 6.96999V17.94C3.5 18.6558 4.09421 19.25 4.81 19.25H10.4264Z",
			fill: "currentColor"
		})
	]
});
export { SvgIconDocumentation as ReactComponent };
